import styled, { css } from 'styled-components';
import ToggleUp from 'images/sports/common/toggle_up.svg';
import ToggleUpOn from 'images/sports/common/toggle_up_on.svg';
import ToggleDown from 'images/sports/common/toggle_down.svg';
import ToggleDownOn from 'images/sports/common/toggle_down_on.svg';
import BetbleLogo from 'images/sports/common/betble_logo.png';
import BetbleFullLogo from 'images/sports/common/betble_full_logo.png';
import XBET from 'images/sports/common/logo/1XBET.png';
import TENBET from 'images/sports/common/logo/10BET.png';
import BET365 from 'images/sports/common/logo/BET365.png';
import DAFABET from 'images/sports/common/logo/DAFABET.png';
import SBOBET from 'images/sports/common/logo/SBOBET.png';
import WILLIAM from 'images/sports/common/logo/WILLIAM.png';
import BETMAN from 'images/sports/common/logo/BETMAN.png';
import ALPHABET from 'images/sports/common/logo/ALPHABET.png';
import X10BET from 'images/sports/common/logo/10X10BET.png';
import BET12 from 'images/sports/common/logo/12BET.png';
import BET188 from 'images/sports/common/logo/188BET.png';
import LADBROKES from 'images/sports/common/logo/LADBROKES.png';
import MACAUSLOT from 'images/sports/common/logo/MACAUSLOT.png';
import MANSION88 from 'images/sports/common/logo/MANSION88.png';
import VICTORCHANDLER from 'images/sports/common/logo/VICTORCHANDLER.png';

export const Container = styled.div`
  width: calc(100% - 60px);
  padding: 0px 30px 40px 30px;
  background: #fff;
`;

export const Title = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: GmarketSansMedium, sans-serif;
  font-size: 22px;
`;

export const OptionWrapper = styled.span`
  display: inline-block;
  margin-left: auto;
`;

export const Option = styled.span`
  cursor: pointer;
  font-size: 12px;
  font-family: Gulim, sans-serif;
  &:not(:last-child) {
    padding: 0 10px;
    border-right: 1px solid #e3e3e3;
  }
  &:last-child {
    padding-left: 10px;
  }

  ${(props) =>
    props.isSelected &&
    css`
      color: #ee1a21;
    `}
`;

export const ToggleButton = styled.div`
  position: absolute;
  cursor: pointer;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  margin-left: auto;
  width: 13px;
  height: 9px;

  &:hover {
    background: url(${(props) => (props.viewSub ? ToggleUpOn : ToggleDownOn)}) no-repeat center center;
  }
  background: url(${(props) => (props.viewSub ? ToggleUp : ToggleDown)}) no-repeat center center;
`;
export const Table = styled.table`
  border-collapse: collapse;
  margin-top: 20px;

  border: 1px solid #e3e3e3;
  & > thead th {
    height: 48px;
    text-align: center;
    background: #fafafa;
    border-bottom: 1px solid #e3e3e3;
  }

  & > tbody > tr td:first-child {
    text-align: center;
  }
  & > tbody > tr:not(.subRow) td {
    height: 45px;
  }

  & tr:not(.subRow):hover ${ToggleButton} {
    background: url(${ToggleDownOn}) no-repeat center center;
  }
  & tr.on:not(.subRow):hover ${ToggleButton} {
    background: url(${ToggleUpOn}) no-repeat center center;
  }
  & > tbody td.winner {
    color: #ee1a21;
  }

  & > tbody > tr:not(.subRow) {
    border-bottom: 1px solid rgb(236, 239, 243);
  }

  & > tbody > tr:last-child {
    border-bottom: none;
  }

  & > tbody > tr > td {
    text-align: center;
    position: relative;
  }
  & > tbody > tr > td:nth-child(1) {
    text-align: left;
    text-indent: 20px;
    text-transform: capitalize;
    position: relative;
    & > em {
      padding-left: 5px;
      color: #0090db;

      &.unover {
        color: #db5500;
      }
    }
  }
  & > tbody > tr > td:nth-child(2) {
    & > em {
      padding-left: 5px;
      color: #0090db;

      &.unover {
        color: #db5500;
      }
    }
  }
`;

export const SiteLogo = styled.div`
  display: inline-block;
  vertical-align: middle;
  height: 25px;
  width: 75px;

  ${(props) =>
    props.siteLogo === 'XBET' &&
    css`
      background: url(${XBET}) no-repeat;
      background-size: cover;
    `}
  ${(props) =>
    props.siteLogo === 'VICTORCHANDLER' &&
    css`
      background: url(${VICTORCHANDLER}) no-repeat;
      background-size: cover;
    `}
  ${(props) =>
    props.siteLogo === 'X10BET' &&
    css`
      background: url(${X10BET}) no-repeat;
      background-size: cover;
    `}
  ${(props) =>
    props.siteLogo === 'BET12' &&
    css`
      background: url(${BET12}) no-repeat;
      background-size: cover;
    `}
  ${(props) =>
    props.siteLogo === 'BET188' &&
    css`
      background: url(${BET188}) no-repeat;
      background-size: cover;
    `}
  ${(props) =>
    props.siteLogo === 'LADBROKES' &&
    css`
      background: url(${LADBROKES}) no-repeat;
      background-size: cover;
    `}
  ${(props) =>
    props.siteLogo === 'MACAUSLOT' &&
    css`
      background: url(${MACAUSLOT}) no-repeat;
      background-size: cover;
    `}
  
  ${(props) =>
    props.siteLogo === 'MANSION88' &&
    css`
      background: url(${MANSION88}) no-repeat;
      background-size: cover;
    `}
  ${(props) =>
    props.siteLogo === 'ALPHABET' &&
    css`
      background: url(${ALPHABET}) no-repeat;
      background-size: cover;
    `}
  ${(props) =>
    props.siteLogo === 'TENBET' &&
    css`
      background: url(${TENBET}) no-repeat;
      background-size: contain;
    `}
    ${(props) =>
    props.siteLogo === 'BET365' &&
    css`
      background: url(${BET365}) no-repeat;
      background-size: contain;
    `}
    ${(props) =>
    props.siteLogo === 'DAFABET' &&
    css`
      background: url(${DAFABET}) no-repeat;
      background-size: contain;
    `}
    ${(props) =>
    props.siteLogo === 'SBOBET' &&
    css`
      background: url(${SBOBET}) no-repeat;
      background-size: contain;
    `}
    ${(props) =>
    props.siteLogo === 'WILLIAM' &&
    css`
      background: url(${WILLIAM}) no-repeat;
      background-size: contain;
    `}
    ${(props) =>
    props.siteLogo === 'BETMAN' &&
    css`
      background: url(${BETMAN}) no-repeat;
      background-size: contain;
    `};
`;

export const BetbleSite = styled.div`
  display: inline-block;
  width: 75px;
  height: 25px;
  vertical-align: middle;
  background: #64666d;
  &:before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background: url(${BetbleFullLogo}) no-repeat center center;
    background-size: 60%;
  }
`;

export const DownIcon = styled.span`
  display: inline-block;
  content: '';
  width: 0;
  height: 0;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  border-top: 4px solid #2a83ff;
  border-bottom: 4px solid transparent;
  margin-left: 8px;
  vertical-align: middle;
`;

export const UpIcon = styled.span`
  display: inline-block;
  content: '';
  width: 0;
  height: 0;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  border-top: 4px solid transparent;
  border-bottom: 4px solid #ed2026;
  margin-left: 8px;
  vertical-align: middle;
`;

export const SubRow = styled.tr`
  background: #f4f2f4;
  & > td {
    height: auto;
    padding: 10px;
  }
`;
